import AppointmentList from "views-vendors/AppointmentList";
import Dashboard from "views-vendors/Dashboard";
import InterpreterList from "views-vendors/Interpreters";
import Payments from "views-vendors/Payments";
import Profile from "views-vendors/profile";
import ChangePassword from "views/ChangePassword";
import VendorSubUsers from "views/VendorSubUsers";


var routesVendors = [
  {
    path: "/dashboard",
    title: "Dashboard",
    icon: "/images/Reports.png",
    iconActive: "/images/Reports-fill.png",
    component: <Dashboard />,
    layout: "/vendor",
  },
  // {
  //   path: "/appointments",
  //   title: "Appointments",
  //   icon: "/images/Reports.png",
  //   iconActive: "/images/Reports-fill.png",
  //   component: <AppointmentList />,
  //   layout: "/vendor",
  // },
  {
    path: "/interpreters",
    title: "Interpreters",
    icon: "/images/calendar-view.png",
    iconActive: "/images/calendar-view.png",
    component: <InterpreterList />,
    layout: "/vendor",
  },
  // {
  //   path: "/sub-users",
  //   title: "Sub Users",
  //   icon: "/images/calendar-view.png",
  //   iconActive: "/images/calendar-view.png",
  //   component: <VendorSubUsers />,
  //   layout: "/vendor",
  // },
  // {
  //   path: "/payments",
  //   title: "Payments",
  //   icon: "/images/admin.png",
  //   iconActive: "/images/admin-active.png",
  //   component: <Payments />,
  //   layout: "/vendor",
  // },
  {
    path: "/profile",
    subRoute: true,
    component: <Profile />,
    layout: "/vendor",
  },
  {
    path: "/change-password",
    subRoute: true,
    component: <ChangePassword />,
    layout: "/vendor",
  },
];
export default routesVendors;
